import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { isBlockedContext, checkServiceWorkerUpdate, didWorkerFail, recoverAppCaches } from '@/pwa/registerServiceWorker';
import { shouldAutoRecover } from '@/pwa/updatePolicy';
import { getAppBusyState } from '@/pwa/busyRegistry';
import { scheduleUpdateChecks } from '@/pwa/updateChecks';
import { getCurrentBuild, recordUpdateCheck, reconcileUpdateVersions, trackStaleBuild, saveRecovery, recordSwError } from '@/pwa/updateState';

export function useAppVersionCheck() {
  useEffect(() => {
    if (isBlockedContext()) return;
    return scheduleUpdateChecks(async () => {
      const [buildResult, dbResult] = await Promise.allSettled([
        fetch('/version.json', { cache: 'no-store', signal: AbortSignal.timeout(8000) }).then(async response => {
          if (!response.ok) return null;
          const json = await response.json();
          return typeof json.build === 'string' ? json.build : null;
        }),
        supabase.rpc('get_app_build_version').abortSignal(AbortSignal.timeout(8000)),
      ]);
      const build = buildResult.status === 'fulfilled' ? buildResult.value : null;
      const db = dbResult.status === 'fulfilled' && !dbResult.value.error && dbResult.value.data
        ? String(dbResult.value.data) : null;
      recordUpdateCheck(build || undefined);
      reconcileUpdateVersions(build, db);
      if (build && build !== getCurrentBuild()) void checkServiceWorkerUpdate();
      // Rede de segurança: preso no build antigo após tentativas/tempo ou falha do SW novo.
      const rec = trackStaleBuild(build);
      if (rec && shouldAutoRecover(rec, build, getCurrentBuild(), Date.now(), didWorkerFail()) && getAppBusyState() === 'free') {
        saveRecovery({ ...rec, cleanedAt: Date.now() });
        recordSwError(`Limpeza automática: preso no build ${getCurrentBuild()} (publicado ${build})`, build);
        void recoverAppCaches();
      }
    });
  }, []);
}
